import React from "react";

const Privacy = () => {
  const PrivacyPolicy = () => {
    return (
      <div
        className="privacy-policy"
        style={{ padding: "20px", maxWidth: "80%", margin: "auto" }}
      >
        <h1>Privacy Policy</h1>

        <p>
          Second Innings built the Track Mate as a Free app. This SERVICE is
          provided by Second Innings at no cost and is intended for use as is.
        </p>

        <p>
          Sole purpose of Track Mate is to assist you in finding your companion
          securely and privately. Whether you are seeking friendship, social
          networking, dating or a serious relationship.
        </p>

        <p>
          This page is used to inform visitors regarding our policies with the
          collection, use, and disclosure of Personal Information if anyone
          decided to use our Service.
        </p>

        <p>
          If you choose to use our Service, then you agree to the collection and
          use of information in relation to this policy. The Personal
          Information that we collect is used for providing and improving the
          Service. We will not use or share your information with anyone except
          as described in this Privacy Policy.
        </p>

        <p>
          The terms used in this Privacy Policy have the same meanings as in our
          Terms and Conditions, which is accessible at Track Mate unless
          otherwise defined in this Privacy Policy.
        </p>

        <h2>Information Collection and Use</h2>
        <p>
          For a better experience, while using our Service, we may require you
          to provide us with certain personally identifiable information,
          including but not limited to name. The information that we request
          will be retained by us and used as described in this privacy policy.
        </p>

        <p>
          The app does use third party services that may collect information
          used to identify you.
        </p>

        <p>
          <strong>
            Link to privacy policy of third party service providers used by the
            app:
          </strong>
        </p>
        <ul>
          <li>Google Play Services</li>
          <li>Google Auth</li>
          <li>Google Analytics for Firebase</li>
          <li>Unity ads</li>
          <li>Google Ads</li>
        </ul>

        <h2>Log Data</h2>
        <p>
          We want to inform you that whenever you use our Service, in a case of
          an error in the app we collect data and information (through third
          party products) on your phone called Log Data. This Log Data may
          include information such as your device Internet Protocol (“IP”)
          address, device name, operating system version, the configuration of
          the app when utilizing our Service, the time and date of your use of
          the Service, and other statistics.
        </p>

        <h3>Privacy Notice</h3>
        <p>
          Do not enter any sensitive or confidential information. We are not
          responsible for any consequences resulting from the information you
          provide.
        </p>

        <h2>User Basic Information</h2>
        <p>
          When you create account, you provide us with at least login
          credentials, as well as some basic details necessary for the service
          to work, such as your name, gender and age.
        </p>
        <p>
          When you create your profile, you share additional information, such
          as details on your personality, interests and other details, as well
          as content such as photos and videos. To add certain content, like
          pictures or videos, you may allow us to access your camera or photo
          album.
        </p>
        <p>
          Some of the information you choose to provide us may be considered
          “special” or “sensitive” in certain jurisdictions, for example your
          racial or ethnic origins, sexual orientation and religious beliefs. By
          choosing to provide this information, you consent to our processing of
          that information.
        </p>
        <p>
          You may be able to use your social media login (such as Google Login)
          to create and log into your Track Mate account. It may be needed for
          account safety and to identify fake profiles.
        </p>

        <h2>Cookies</h2>
        <p>
          Cookies are files with a small amount of data that are commonly used
          as anonymous unique identifiers. These are sent to your browser from
          the websites that you visit and are stored on your device’s internal
          memory.
        </p>
        <p>
          This Service does not use these “cookies” explicitly. However, the app
          may use third party code and libraries that use “cookies” to collect
          information and improve their services. You have the option to either
          accept or refuse these cookies and know when a cookie is being sent to
          your device. If you choose to refuse our cookies, you may not be able
          to use some portions of this Service.
        </p>

        <h2>Service Providers</h2>
        <p>
          We may employ third-party companies and individuals due to the
          following reasons:
        </p>
        <ul>
          <li>To facilitate our Service;</li>
          <li>To provide the Service on our behalf;</li>
          <li>To perform Service-related services; or</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>
        <p>
          We want to inform users of this Service that these third parties have
          access to your Personal Information. The reason is to perform the
          tasks assigned to them on our behalf. However, they are obligated not
          to disclose or use the information for any other purpose.
        </p>

        <h2>Security</h2>
        <p>
          We value your trust in providing us your Personal Information, thus we
          are striving to use commercially acceptable means of protecting it.
          But remember that no method of transmission over the internet, or
          method of electronic storage is 100% secure and reliable, and we
          cannot guarantee its absolute security.
        </p>

        <h2>Links to Other Sites</h2>
        <p>
          This Service may contain links to other sites. If you click on a
          third-party link, you will be directed to that site. Note that these
          external sites are not operated by us. Therefore, we strongly advise
          you to review the Privacy Policy of these websites. We have no control
          over and assume no responsibility for the content, privacy policies,
          or practices of any third-party sites or services.
        </p>

        <h2>Children’s Privacy</h2>
        <p>
          These Services do not address anyone under the age of 18. We do not
          knowingly collect personally identifiable information from children
          under 18. In the case we discover that a child under 18 has provided
          us with personal information, we immediately delete this from our
          servers. If you are a parent or guardian and you are aware that your
          child has provided us with personal information, please contact us so
          that we will be able to do necessary actions.
        </p>

        <h2>Why Collecting Information</h2>
        <p>
          The main reason we use your information is to deliver and improve our
          services. Additionally, we use your info to help keep you safe and to
          provide you with advertising that may be of interest to you. Read on
          for a more detailed explanation of the various reasons we use your
          information, together with practical examples.
        </p>
        <ul>
          <li>Create and manage your account</li>
          <li>
            Provide you with customer support and respond to your requests
          </li>
          <li>
            Communicate with you about our services, including order management
            and billing
          </li>
          <li>
            Analyze your profile and that of other users to recommend meaningful
            connections
          </li>
          <li>Show users’ profiles to one another</li>
        </ul>

        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. Thus, you are
          advised to review this page periodically for any changes. We will
          notify you of any changes by posting the new Privacy Policy on this
          page.
        </p>
        <p>
          This policy is effective as of <strong>2026-06-15</strong>
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions or suggestions about our Privacy Policy, do
          not hesitate to contact us.
        </p>
      </div>
    );
  };

  return (
    <div>
      <PrivacyPolicy />
    </div>
  );
};

export default Privacy;
